
import { Theme } from "@emotion/react";
import { SxProps, TextField as MuiTextField } from "@mui/material";
import { ChangeEvent, InputHTMLAttributes } from "react";

const defaultTextFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: 44,
    fontSize: 14,
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "rgba(0,0,0,0.12)" },
  },
};

interface TextFieldProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  required?: boolean;
  placeholder?: string;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  maxLength?: number;
  sx?: SxProps<Theme>;
  type?: InputHTMLAttributes<HTMLInputElement>["type"];
}

const TextField = ({
  value,
  onChange,
  fullWidth,
  required,
  placeholder,
  inputProps,
  maxLength,
  sx,
  type,
}: TextFieldProps) => {
  return (
    <MuiTextField
      type={type}
      fullWidth={fullWidth}
      required={required}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      inputProps={{ maxLength, ...inputProps }}
      sx={{ ...defaultTextFieldSx, ...sx }}
    />
  );
};

export default TextField;